// Permission gate for the assessment- and association-level "request RSVPs by
// default" controls. Kept apart from `attendance.helpers.tsx` so that file
// stays a pure, import-light module: this one pulls in `hasAnyRoles` (a hook
// chain → member service → Apollo), so callers must invoke it at render time,
// never inside an event handler. See "Render visibility and data visibility
// are one decision" in CLAUDE.md.

import { hasAnyRoles } from '../../lib/services/user.service';
import { ROLES } from '../../../_configuration';

export const canEditAttendanceDefault = (): boolean =>
  hasAnyRoles({ roles: [ROLES.CONFIGURATION] });
